module.exports = __webpack_public_path__ + "media/assets/Delete-10a35f2c5a1fa6e20960aef97a4c5239.svg";